import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { PermissionsSection } from '@/components/access/PermissionsSection'
import { RolesSection } from '@/components/access/RolesSection'
import { permissionsQuery, rolesQuery } from '@/lib/queries'

/** The Roles & permissions tab — role/permission CRUD, unchanged from the pre-tabs page. */
export const Route = createFileRoute('/app/access/roles')({
  loader: ({ context }) =>
    Promise.all([
      context.queryClient.ensureQueryData(permissionsQuery),
      context.queryClient.ensureQueryData(rolesQuery),
    ]),
  component: RolesTab,
})

function RolesTab() {
  const { data: permissionsData } = useSuspenseQuery(permissionsQuery)
  const { data: rolesData } = useSuspenseQuery(rolesQuery)

  return (
    <div className="flex flex-col gap-8">
      <PermissionsSection permissions={permissionsData.permissions} />
      <RolesSection roles={rolesData.roles} permissions={permissionsData.permissions} />
    </div>
  )
}
